import { useContext } from 'react';
import { CatalogDispatchContext } from '../store/CatalogContext';
import { getDisplayPrice } from '../utils/amountHelper';
import { formatCurrency } from '../utils/formatCurrency';
import type { ProductState, UpsellItem } from '../types/product';

interface ProductUpsellsProps {
  upsells: UpsellItem[] | [];
  setProductState: React.Dispatch<React.SetStateAction<ProductState>>;
}

export default function ProductUpsells({ upsells, setProductState }: ProductUpsellsProps) {
  const catalogDispatch = useContext(CatalogDispatchContext);

  if (!upsells || upsells.length === 0) {
    return null; // No upsells to display
  }

  const accessoryUpsells = upsells
    .filter((item) => item.upsellType === 'Accessory')
    .sort((a, b) => a.upsellOrderIndex - b.upsellOrderIndex);

  const handleUpsellDescriptionModal = (upsellItem: UpsellItem) => {
    const upsellData = {
      name: upsellItem?.name,
      description: upsellItem?.description,
    };

    catalogDispatch({
      type: 'UX',
      payload: {
        showUpsellDescription: upsellData,
      },
    });
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked, value } = event.target;

    setProductState((prevState) => ({
      ...prevState,
      upsells: upsells.map((item) => (item.id === value ? { ...item, isSelected: checked } : item)),
    }));

    setProductState((prevState) => {
      const updatedUpsells = upsells.map((item) => (item.id === value ? { ...item, isSelected: checked } : item));
      const selectUpsells = updatedUpsells.filter((item: UpsellItem) => item.isSelected).map((item: UpsellItem) => item.id);

      return {
        ...prevState,
        upsells: updatedUpsells,
        selectedUpsellProductIds: selectUpsells,
      };
    });
  };

  const upsellItems = accessoryUpsells.map((upsell, index) => (
    <div key={`${upsell?.id}-${index}`} className="form-check mb-2">
      <input
        className="form-check-input"
        type="checkbox"
        id={`upsell-id-${upsell?.id}-${index}`}
        data-cart-product-id={upsell?.id}
        data-upsell-type="Accessory"
        value={upsell?.id}
        onChange={handleChange}
        checked={upsells.some((item) => item.id === upsell?.id && item.isSelected)}
      />
      <div className="d-flex justify-content-between">
        <label className="form-check-label d-block pe-2" htmlFor={`upsell-id-${upsell?.id}-${index}`}>
          <span className="upsell-name d-inline-block">
            {upsell?.name}
            <button
              className="btn-toggle fw-400 small text-reset lh-1 p-0"
              type="button"
              onClick={() => handleUpsellDescriptionModal(upsell)}
            >
              <span className="info-icon align-middle">?</span>
            </button>
          </span>
        </label>
        <span className="price text-end">+{formatCurrency(getDisplayPrice(upsell, true))}</span>
      </div>
    </div>
  ));

  return (
    <div className="product-upsells mt-3">
      <h4 className="fs-6">Include:</h4>
      {upsellItems}
    </div>
  );
}
